<template>
  <div class="app">

    <!-- Chat window -->
    <v-menu
      v-model="isOpen"
      :close-on-content-click="false"
      transition="scale-transition" origin="bottom right"
      left nudge-right="8"
      top nudge-bottom="8"
      content-class="chat-window"
      z-index="4"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on"
          fixed fab small bottom right v-show="isExist"
          :color="isAgents ? 'success' : 'primary'"
          :depressed="isOpen"
          style="z-index: 5"
        ><v-icon size="24">
            {{ isAgents ? "message" : "sms_failed" }}
          </v-icon>
        </v-btn>
      </template>

      <v-card width="100%" max-width="360">
        <!-- HEADER -->
        <v-card-title>
          <v-list-tile-avatar color="secondary lighten-1">
            <v-icon dark>account_circle</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{profile.name}}</v-list-tile-title>
            <v-list-tile-sub-title class="caption text-xs-right">
              <div v-if="isAgents" class="secondary--text">
                {{ $t('Chat session started') }}
                <v-icon small color="secondary">timer</v-icon><span> {{ sessionTimestamp }}</span></div>
              <div v-else class="blue--text text--lighten-3">
                {{ sessionStatus }}
                <v-icon small color="blue lighten-3">timer_off</v-icon></div>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-card-title>

        <v-divider></v-divider>

        <!-- BODY: POSTS -->
        <v-card-text style="height: 396px; overflow-x: hidden; overflow-y: auto" ref="postsContainer" class="pa-0">
          <template v-for="(post, index) in posts">
            <div v-if="post.history && post.history.timestamp"
              class="timestamp ma-1 text-xs-center caption blue-grey--text"
            ><v-icon size="12">timer</v-icon> {{ post.history.timestamp }}
            </div>
            <v-card :key="index"
              tile flat
              :class="[
                post.poster,
                post.poster == 'AGENT' ? 'mr-3 blue lighten-4 blue--text text--darken-1' : 'ml-3 secondary lighten-3 secondary--text',
                {'HISTORY': post.history},
              ]"
              class="my-1"
              ref="post"
            >
              <v-layout row fill-height class="pa-1">
                <v-flex shrink
                  :class="{'order-xs2 text-xs-right': post.poster == 'AGENT'}"
                  align-self-end
                >
                  <v-icon
                    :color="post.poster == 'AGENT' ? 'blue' : 'secondary'"
                    :class="{'fa-spin': post.isPending}"
                  >{{ post.icon }}</v-icon>
                </v-flex>
                <v-flex class="px-3">
                  <span v-html="post.message"></span>
                  <div v-if="post.timestamp" class="timestamp mt-1 text-xs-right caption blue-grey--text text--darken-1">
                    <span v-if="post.isPending">... {{ $t("pending") }}...</span>
                    <span v-else-if="post.isPending == null && post.poster == 'USER'">{{ $t("Error receiving") }}</span>
                    <span v-else>
                      <v-icon size="12">access_time</v-icon> {{ post.timestamp }} <span class="blue-grey--text text--lighten-2 ml-2">#{{ index+1 }}</span>
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <!-- FOOTER: Actions -->
        <v-card-actions>
          <v-text-field
            v-model="userInput"
            class="pa-0 ml-2 mr-4"
            :label="$t('Message')"
            :append-icon="userInput != '' ? 'send' : null" :append-icon-cb="send"
            @keyup.enter="send"
            @keyup.up="prevUserInput != '' ? userInput = prevUserInput : null"
            hide-details
            id="userInput"
          ></v-text-field>
          <span style="width: 40px; height: 40px;"></span>
        </v-card-actions>
      </v-card>
    </v-menu>

  </div>
</template>

<script>
import { STORE_KEY_CHAT_SESSION_ID } from "../constants";
import { save, read } from "../storage";

export default {
  name: "chat-module",
  props: {
    value: { type: Boolean, default: true },// Layout.vue: <chat-module v-model="chat">
    profile: {}
  },
  data() {
    return {
      isExist: this.value,
      isOpen: false,
      isOpenAlready: false,
      isAgents: false,
      timerAgents: null,
      timerAgentPosts: null,
      sessionId: "",
      sessionTimestamp: null,
      sessionStatus: "",
      //
      SERVICE_URL: process.env.VUE_APP_CHAT_ENDPOINT,//"/3DX_1001",
      TIMER_AGENTS_INTERVAL_SEC: 10,
      TIMER_POSTS_INTERVAL_SEC: 5,
      SOUND: new Audio("./static/chat-notify.wav"),// wav|mp3|ogg
      IS_IE: (!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || /Edge/.test(navigator.userAgent)),
      //
      isPostsContainerViewAreaWinClosed: true,
      userInput: "",
      prevUserInput: "",
      posts: [],
      posters: {
        USER: {// = client
          icon: this.profile.icon || this.profile.avatar || "account_circle",
          iconPending: "data_usage",
        },
        AGENT: {
          icon: "accessibility_new",
        },
      },
    }
  },
  computed: {
    postsContainer() {
      return this.$refs.postsContainer;
    },
  },
  created() {
    // Session: read or create (unique) session id, to send to service
    this.sessionId = read( STORE_KEY_CHAT_SESSION_ID ) || new Date().valueOf().toString();
    save( STORE_KEY_CHAT_SESSION_ID, this.sessionId );
  },
  destroyed() {
    // Kill posts-request interval
    clearInterval(this.timerAgents);
    clearInterval(this.timerAgentPosts);
  },
  watch: {
    value(val) {// v-model of component
      this.isExist = val;
    },
    isExist(val) {
      if (val === false) {
        clearInterval( this.timerAgents );
      }
      this.$emit("input", val); // need to trigger change on component parent's v-model
    },
    isOpen(val) {
      if (val === true) {
        if (this.isOpenAlready !== true)
          this.isOpenAlready = true;

        if (this.isPostsContainerViewAreaWinClosed) {
          setTimeout(this.scroll.bind(this), 500);
        }
        setTimeout(() => document.querySelector("#userInput").focus(), 500);
      }
      else {
        this.isPostsContainerViewAreaWinClosed = this.isPostsContainerViewArea();
      }
    },
    isOpenAlready(val) {
      console.log("session Id = " + this.sessionId);
      if (val === true) {
        this.getHistory();

        this.timerAgents = setInterval( this.getAgents.bind(this), 1000 * this.TIMER_AGENTS_INTERVAL_SEC );
        this.getAgents();
      }
    },
    isAgents(val) {
      if (val === true) {// Start chat session when has available agents.
        this.timerAgentPosts = setInterval( this.getAgentPosts.bind(this), 1000 * this.TIMER_POSTS_INTERVAL_SEC );
        this.getAgentPosts();
      }
      else {// No agents.
        clearInterval(this.timerAgentPosts);
      }
    },
  },
  methods: {
    send() {// Send user post
      if (this.userInput.trim() == "")
        return;

      let userMsg = this.userInput.replace(/\n/g, " ");

      let postIndex = this.renderPost({
        poster: "USER",
        message: userMsg,
        timestamp: this.formatTimestamp(new Date()),
        isPending: true,
      });
      this.prevUserInput = this.userInput;
      this.userInput = "";

      // Request user post
      let params = "<DATA><COMMAND>SENDCHATMESSAGE</COMMAND><CHATSESSION>" + this.sessionId +
        "</CHATSESSION><MESSAGE>" + userMsg + "</MESSAGE></DATA>";

      this.$http.post(this.SERVICE_URL, params).then(response => {
        let response_body = new DOMParser().parseFromString( response.body, "text/xml" );
        if (response.status == 200) {
          if (response_body.querySelector("CODE") && response_body.querySelector("CODE").textContent.toString() == "0") {
            this.posts[ postIndex ].icon = this.posters["USER"].icon;
            this.posts[ postIndex ].isPending = false;
          }
          else {
            this.posts[ postIndex ].isPending = null;
          }
        }
        console.log("Ok user post, CODE = " + response_body.querySelector("CODE").textContent + ", TEXT = " + response_body.querySelector("TEXT").textContent);
      }).catch(error => {
        console.log("Error user post", error.status);
      }).finally(() => {
      });

    },
    getHistory() {// Request previous session posts history
      let params = "<DATA><COMMAND>GETALLCHATMESSAGEs</COMMAND><CHATSESSION>" + this.sessionId + "</CHATSESSION></DATA>";

      this.$http.post(this.SERVICE_URL, params).then(response => {
        let response_body = new DOMParser().parseFromString( response.body, "text/xml" );
        if (response.status == 200) {
          if (response_body.querySelector("CODE") && response_body.querySelector("CODE").textContent.toString() == "0") {
            this.processHistory(response_body);
          }
          else {
            // case still unknown
          }
        }
        console.log("Ok posts history, CODE = " + response_body.querySelector("CODE").textContent + ", TEXT = " + response_body.querySelector("TEXT").textContent);
      }).catch(error => {
        console.log("Error posts history", error.status);
      }).finally(() => {
      });
    },
    processHistory(response_body) {
      let timestamp = response_body.querySelector("TIMESTAMP").innerHTML,
          messages  = response_body.querySelector("TEXTDATA").innerHTML;

      let thisvue = this;
      messages.split("|").forEach((post, index) => {
        // parse sender: A:gent or C:lient
        let data = {
          poster: post.trim().startsWith("C:") ? "USER" : "AGENT",
          message: post.trim().substr(2),
          history: { timestamp: index == 0 ? timestamp : null },
        }
        thisvue.renderPost( data );
      });
    },
    getAgents() {// Request available agents
      let params = "<DATA><COMMAND>GETAVAILABLEAGENTS</COMMAND></DATA>";

      this.$http.post(this.SERVICE_URL, params, {
        headers: {
          "Accept": "text/xml",
          "Content-Type": "text/xml;charset=UTF-8"
        }
      }).then(response => {
        let response_body = new DOMParser().parseFromString( response.body, "text/xml" );
        if (response.status == 200 && response_body.querySelector("AVAILABLEAGENTS")) {
          if (response_body.querySelector("AVAILABLEAGENTS").textContent == "TRUE") {
            this.isAgents = true;
            this.sessionTimestamp = response_body.querySelector("TIMESTAMP").textContent;
          }
          else {
            this.sessionStatus = this.$t("No available agents");
          }
        }
        console.log("Ok available agents, COUNT agents = " + response_body.querySelector("COUNT").textContent);
        // this.isAgents = true;//@@DEL
      }).catch(error => {
        console.log("Error available agents", error.status);
        this.isAgents = false;
        this.sessionStatus = this.$t("Session unavailable");
      }).finally(() => {
      });
    },
    getAgentPosts() {// Request agent posts
      let params = "<DATA><COMMAND>GETCHATMESSAGE</COMMAND><CHATSESSION>" + this.sessionId + "</CHATSESSION></DATA>";

      this.$http.post(this.SERVICE_URL, params).then(response => {
        let response_body = new DOMParser().parseFromString( response.body, "text/xml" );
        if (response.status == 200) {
          if (response_body.querySelector("CODE") && response_body.querySelector("CODE").textContent.toString() == "0") {
            this.renderPost({
              poster: "AGENT",
              message: response_body.querySelector("MESSAGE").innerHTML,
              timestamp: response_body.querySelector("TIMESTAMP").innerHTML,
            });
          }
          else {
            // case still not known
          }
        }
        console.log("Ok agent posts, CODE = " + response_body.querySelector("CODE").textContent + ", TEXT = " + response_body.querySelector("TEXT").textContent);
      }).catch(error => {
        console.log("Error agent posts", error.status);
      }).finally(() => {
      });
    },
    renderPost(data) {// = parseMsg|renderMsg|formatMsg|renderPost
      let poster  = data.poster;
      let post = {
        poster,
        icon: data.isPending ? this.posters[poster].iconPending : this.posters[poster].icon,
        timestamp: data.timestamp,
        message: this.renderEmoticons(data.message),
        history: data.history ? { timestamp: data.history.timestamp } : null,
        isPending: data.isPending ? true : null,
      };
      new Promise( function(resolve, reject) {
        this.posts.push(post);
        resolve();
      }.bind(this) ).then( function() {
        this.scroll(poster);
      }.bind(this) );

      /*-------------------- Sound --------------------*/
      if (this.SOUND) {
        this.SOUND.volume = (document.hasFocus() || poster == "CLIENT" ? 0.3 : 1);
        this.SOUND.play().catch(e => console.log("Cannot play chat sound", e));
      }

      return this.posts.length-1;
    },
    isPostsContainerViewArea() {// Whether viewable area is near last post
      return this.postsContainer.scrollHeight - this.postsContainer.offsetHeight - 100 <= this.postsContainer.scrollTop;
    },
    scroll(poster) {// Scroll to bottom (last post)
      // USER: always scroll; AGENT: only if near bottom
      if (!poster) {
        this.postsContainer.scrollTop = this.postsContainer.scrollHeight;
      }
      else if (poster == "USER" || (poster == "AGENT" && this.isPostsContainerViewArea()) ) {
        let lastPost = this.$refs.post[this.$refs.post.length-1].$el; // Last post tag
        if (!this.IS_IE) {
          let thisvue = this;
          this.postsContainer.scrollTo({
            top: thisvue.postsContainer.scrollHeight,
            behavior: "smooth"
          });
        }
        else {// IE n Edge
          this.postsContainer.scrollTop = lastPost.offsetTop;
        }
      }
    },
    formatTimestamp(timestamp) {// Convert to service response's TIMESTAMP format: dd.mm.yyyy hh:MM:ss
      if (!timestamp) return "";
      let d = new Date( timestamp ),
          year  = d.getFullYear(),
          month = ("0" + (d.getMonth()+1) ).slice(-2),
          day   = ("0" + d.getDate() ).slice(-2),
          hour  = ("0" + d.getHours() ).slice(-2),
          min   = ("0" + d.getMinutes() ).slice(-2),
          sec   = ("0" + d.getSeconds() ).slice(-2);

      return `${day}.${month}.${year} ${hour}:${min}:${sec}`;
    },
    renderEmoticons(text) {// Parse emoticons
      if (!text) return "";
      let emojis = {
        ":)"     : "smile",       // Smiley face
        ":D"     : "grin-alt",    // Grinning
        ":("     : "frown",       // Frowny face
        ":'("    : "sad-tear",    // Crying
        ":P"     : "grin-tongue", // Tongue out
        "O:)"    : "grin-stars",  // Angel smiley (~~)
        "3:)"    : "grin-squint", // Devil smiley (~~)
        "o.O"    : "surprise",    // Surprised
        ";)"     : "smile-wink",  // Winking
        ":O"     : "dizzy",       // Gasping - ахващ (~dizzy|flushed)
        "-_-"    : "meh",         // Squinting (~)
        ">:O"    : "tired",       // Upset (~~)
        ":*"     : "kiss-beam",   // Kiss
        "^_^"    : "grin-beam",   // ----- 2nd line -----
        // "8-)"    : "",         // (glasses)
        // "8|"     : "",         // (the man|i'm cool)
        ">:("    : "angry",       // Grumpy
        // ":v"     : "",         // Pacman
        // ":/"     : "",         // Unsure
        ":3"     : "kiss",        // Curly lips (~)
        // ----- non-human/non-face -----
        "<3"     : "heart",       // Heart emoticon
        "(y)"    : "thumbs-up",   // Thumbs up
        // "(^^^)"  : "",         // Shark
        // '<(")'   : "",         // Penguin
        ":|]"    : "robot",       // Robot
        ":poop:" : "poo",         // Poop
      };
      text = Object.keys(emojis).reduce((result, key) => {
        return result.replace(key, this.iconTagWrap(emojis[key]));
      }, text);
      return text;
    },
    iconTagWrap(icon) {
      // fas-solid or far-regular
      return "<i class='far fa-" + icon + "'></i>";
    },

  }
}
</script>

<style scoped>
.chat-window {
  border-radius: 2px 2px 25px 2px;
}
.timestamp {
  font-size: 70% !important;
  line-height: 100%;
}
.AGENT {
  border-radius: 0 16px 16px 0;
}
.USER {
  border-radius: 16px 0 0 16px;
}
.HISTORY {
  opacity: 0.5;
}
</style>
